<template>
  <div class="export-report">
    <ElDropdown
      trigger="click"
      :disabled="disabled"
      placement="bottom"
    >
      <slot>
        <UiButton icon="download" :disabled="disabled" />
      </slot>

      <template v-slot:dropdown>
        <ElDropdownMenu class="dropdown-exportlink ddgroup">
          <ElDropdownItem>
            <a
              :href="getExportLink('csv')"
              target="_blank"
            >
              <i class="fal fa-file-csv mr-4" />
              CSV
            </a>
          </ElDropdownItem>
          <ElDropdownItem>
            <a
              :href="getExportLink('xlsx')"
              target="_blank"
            >
              <i class="fal fa-file-spreadsheet mr-4" />
              XLSX
            </a>
          </ElDropdownItem>
        </ElDropdownMenu>
      </template>
    </ElDropdown>
  </div>
</template>


<script>
export default {
  name: 'ExportReport',
  props: {
    query: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    exportLinks: {
      type: [Object, String],
      default: () => ({}),
    },
  },
  methods: {
    getExportLink(format) {
      return this.exportLinks[format] || `${this.query}&export_format=${format}&access_token=${encodeURIComponent(this.$store.state.auth.userToken)}`;
    },
  },
};
</script>
